import { ClickableOptionsCard } from 'core/Components';
import { useDisclosure } from 'ui/Hooks';

import LogoutConfirmation from '../../../../components/modals/logoutConfirmation/LogoutConfirmation';

const SignOutRowAction = () => {
  const [isSignOutModalOpened, signOutModalHandlers] = useDisclosure(false);

  return (
    <>
      <ClickableOptionsCard variant="gray">
        <ClickableOptionsCard.Row title="Sign Out" onClick={signOutModalHandlers.open} />
      </ClickableOptionsCard>
      <LogoutConfirmation
        visibility={isSignOutModalOpened}
        handleClose={signOutModalHandlers.close}
      />
    </>
  );
};

export { SignOutRowAction };
